// extracted by mini-css-extract-plugin
export var canvas = "_a-1";
export var container = "_a-0";
export var fallback = "_a-2";